/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {FormControl, FormGroup} from "@angular/forms";
import { JSONable } from "@irian-ro/abstract-resource";
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

export class SubscriptionLegalEntityDtoModel  extends JSONable {

  uuid: string | undefined = undefined;

  companyName: string | undefined = undefined;

  cui: string | undefined = undefined;

  companyType: CompanyType | undefined = undefined

  static createForm() {
    return new FormGroup({
      uuid: new FormControl(null),
      companyName: new FormControl(null),
      cui: new FormControl(null)
    })
  }

}
